import {
  FETCH_PROFILES_SUGGESTIONS_ASYNC,
  GET_PREVIEW_ASYNC,
  RESET_MANAGER,
  SET_PRESELECTED_LOCAL_ID,
  SET_SCENARIO_PREVIEW_SWITCHER,
  TEST_SCENARIO_ASYNC,
} from './constants'

export const getPreview = (id, locale) => ({
  type: GET_PREVIEW_ASYNC.INITIATE,
  payload: { id, locale },
})
export const getPreviewSuccess = (data) => ({
  type: GET_PREVIEW_ASYNC.SUCCESS,
  payload: { data },
})
export const getPreviewError = (error) => ({
  type: GET_PREVIEW_ASYNC.ERROR,
  error,
})

const testScenario = (id, locale, values, deliveryType) => ({
  type: TEST_SCENARIO_ASYNC.INITIATE,
  payload: { id, locale, values, deliveryType },
})
export const testScenarioSuccess = (data) => ({
  type: TEST_SCENARIO_ASYNC.SUCCESS,
  payload: { data },
})
export const testScenarioError = (error) => ({
  type: TEST_SCENARIO_ASYNC.ERROR,
  error,
})
const testScenarioCancel = () => ({ type: TEST_SCENARIO_ASYNC.CANCEL })

const fetchProfilesSuggestions = (search) => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.INITIATE,
  payload: { search },
})
export const fetchProfilesSuggestionsSuccess = (data) => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchProfilesSuggestionsError = (error) => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.ERROR,
  error,
})
const fetchProfilesSuggestionsCancel = () => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.CANCEL,
})

const getPreviewCancel = () => ({ type: GET_PREVIEW_ASYNC.CANCEL })

export const setScenarioPreviewSwitcher = (value) => ({
  type: SET_SCENARIO_PREVIEW_SWITCHER,
  payload: { value },
})

export const setPreselectedLocaleId = (value) => ({
  type: SET_PRESELECTED_LOCAL_ID,
  payload: { value },
})

const resetManager = () => ({ type: RESET_MANAGER })

export default {
  // to props
  getPreview,
  getPreviewCancel,
  resetManager,
  setScenarioPreviewSwitcher,
  fetchProfilesSuggestions,
  fetchProfilesSuggestionsCancel,
  testScenario,
  testScenarioCancel,
}
